import React from "react";
import {
  List,
  TextField,
  Datagrid,
  NumberField,
  DateField,
  TextInput,
  ReferenceInput,
  SimpleList,
  FunctionField,
  TopToolbar,
  CreateButton,
  AutocompleteInput,
} from "react-admin";
import { MOBILE_BREAKPOINT, PAYMENT_EXPECTATIONS } from "utils/constants";
import { useMediaQuery } from "@mui/material";
import { EmptyList } from "server/components";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import { formatDateBg } from "../../../server/formatting/formatDateBg";
import ReceivePaymentDialog from "./ReceivePaymentDialog";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { CashflowExporter } from "../XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { candidateRequests } from "api/candidateApi";

const filters = [
  <TextInput
    label="Име"
    source="firstName"
    style={{ width: 250 }}
    alwaysOn
  />,
  <TextInput
    label="Фамилия"
    source="lastName"
    style={{ width: 250 }}
    alwaysOn
  />,
  <TextInput
    label="Вх. номер"
    source="admissionNumber"
    style={{ width: 150 }}
    alwaysOn
  />,
  <ReferenceInput
    source="campaignId"
    reference={candidateRequests.getCampaignsSelect()}
    filter={{ activeOnly: true }}
    label="Кампания"
    alwaysOn
  >
    <AutocompleteInput
      style={{ width: 400 }}
      label="Кампания"
      optionText={"nameBg"}
      filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
    />
  </ReferenceInput>,
];

const ListPaymentExpectations = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={CashflowExporter(PAYMENT_EXPECTATIONS)} />
      </TopToolbar>
    );
  };

  return (
    <List
      actions={<ListActions hasCreate={true} />}
      title="Очаквани плащания"
      filters={filters}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "ИД кандидатура", value: record.id }]} />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Вх. номер", value: record.admissionNumber }]} />
              <MobileListRow fields={[{ label: "Име", value: record.firstName }]} />
              <MobileListRow fields={[{ label: "Презиме", value: record.secondName }]} />
              <MobileListRow fields={[{ label: "Фамилия", value: record.lastName }]} />
              <MobileListRow fields={[{ label: "Сума", value: record.amount }]} />
              <MobileListRow fields={[{ label: "Валута", value: record.currency }]} />
              <MobileListRow fields={[{ label: "Описание", value: record.description }]} />
              <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                <SecuredComponent permission={permissions.canReceivePaymentExpectations}>
                  <ReceivePaymentDialog candidacyId={record?.id} />
                </SecuredComponent>
              </div>
            </div>
          )}
          tertiaryText={record => (
            <MobileListRow fields={[{ label: "Дата", value: formatDateBg(record.createdOn) }]} />
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <NumberField
            textAlign="center"
            source="id"
            label="ИД кандидатура"
            sortable={false}
          />
          <TextField
            source="admissionNumber"
            label="Вх. номер"
            sortable={false}
          />
          <TextField
            source="firstName"
            label="Име"
            sortable={false}
          />
          <TextField
            source="secondName"
            label="Презиме"
            sortable={false}
          />
          <TextField
            source="lastName"
            label="Фамилия"
            sortable={false}
          />
          <TextField
            source="amount"
            label="Сума"
            sortable={false}
          />
          <TextField
            source="currency"
            label="Валута"
            sortable={false}
          />
          <DateField
            source="createdOn"
            label="Дата"
            showTime
            locales="bg-BG"
            sortable={false}
          />
          <TextField
            source="description"
            label="Описание"
            sortable={false}
          />
          <SecuredComponent permission={permissions.canReceivePaymentExpectations}>
            <FunctionField render={rec => <ReceivePaymentDialog candidacyId={rec?.id} />} />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};

export default ListPaymentExpectations;
